/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class ApplicationsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getContext: (
        ): string => {
            let clientRequestUrl = '/api/v3/applications/context';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves the execution context of the application.
     * @return OK
     */
    getContext(): Promise<ApplicationContext> {
        const clientRequestUrl = this.baseUrl + this.routes.getContext(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ApplicationContext>(_response, false, []);
        });
    }
}

export class BookmarksClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getUserBookmarks: (
        ): string => {
            let clientRequestUrl = '/api/v3/bookmarks';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        createUserBookmark: (
        ): string => {
            let clientRequestUrl = '/api/v3/bookmarks';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v3/bookmarks/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        deleteBookmark: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v3/bookmarks/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all bookmarks for the current user.
     * @return OK
     */
    getUserBookmarks(): Promise<GetUserBookmarksResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getUserBookmarks(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUserBookmarksResponse>(_response, false, ['beginDate']);
        });
    }

    /**
     * Creates a new bookmark for the current user.
     * @param body (optional) The details of the bookmark to create.
     * @return OK
     */
    createUserBookmark(body?: CreateBookmarkDto | undefined): Promise<BookmarkResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.createUserBookmark(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<BookmarkResponse>(_response, false, ['beginDate']);
        });
    }

    /**
     * Retrieves a specific bookmark by its ID.
     * @param id The ID of the bookmark to retrieve.
     * @return OK
     */
    getById(id: number): Promise<BookmarkResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<BookmarkResponse>(_response, false, ['beginDate']);
        });
    }

    /**
     * Deletes a bookmark by its ID.
     * @param id The ID of the bookmark to delete.
     * @return No Content
     */
    deleteBookmark(id: number): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.deleteBookmark(
            id,
        );

        const options = {
            method: 'DELETE',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }
}

export class HighlightLayoutsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getHighlightLayoutForMe: (
			page?: HighlightLayoutPage | undefined,
			categoryKey?: string | undefined,
			language?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/highlight-layouts/me?';
            if (page === null) {
                throw new Error('The parameter "page" cannot be null.');
            } else if (page !== undefined) {
                clientRequestUrl += 'page=' + encodeURIComponent('' + page) + '&';
            }
            if (categoryKey === null) {
                throw new Error('The parameter "categoryKey" cannot be null.');
            } else if (categoryKey !== undefined) {
                clientRequestUrl += 'categoryKey=' + encodeURIComponent('' + categoryKey) + '&';
            }
            if (language === null) {
                throw new Error('The parameter "language" cannot be null.');
            } else if (language !== undefined) {
                clientRequestUrl += 'language=' + encodeURIComponent('' + language) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieve highlight layouts for the current user.
     * @param page (optional) The page of highlight layouts to retrieve.
     * @param categoryKey (optional) The category key for filtering layouts.
     * @param language (optional) The language of the layouts. Defaults to "EN".
     * @return OK
     */
    getHighlightLayoutForMe(page?: HighlightLayoutPage | undefined, categoryKey?: string | undefined, language?: string | undefined): Promise<MyHighlightLayoutsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getHighlightLayoutForMe(
            page,
            categoryKey,
            language,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<MyHighlightLayoutsResponse>(_response, false, ['publicationDateUtc']);
        });
    }
}

export class InfoServicesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getServiceList: (
        ): string => {
            let clientRequestUrl = '/api/v3/info-services';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getService: (
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v3/info-services/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves the list of all info services.
     * @return OK
     */
    getServiceList(): Promise<GetServiceListResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getServiceList(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetServiceListResponse>(_response, false, []);
        });
    }

    /**
     * Retrieves a single info service by its identifier.
     * @param id Service key of a service
     * @return OK
     */
    getService(id: string): Promise<InfoService> {
        const clientRequestUrl = this.baseUrl + this.routes.getService(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<InfoService>(_response, false, []);
        });
    }
}

export class LearnMoresClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getAvailableLearnMore: (
			detailed?: boolean | undefined,
			includeAll?: boolean | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/learn-mores?';
            if (detailed === null) {
                throw new Error('The parameter "detailed" cannot be null.');
            } else if (detailed !== undefined) {
                clientRequestUrl += 'detailed=' + encodeURIComponent('' + detailed) + '&';
            }
            if (includeAll === null) {
                throw new Error('The parameter "includeAll" cannot be null.');
            } else if (includeAll !== undefined) {
                clientRequestUrl += 'includeAll=' + encodeURIComponent('' + includeAll) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        markAsReadLearnMore: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v3/learn-mores/{id}/do-mark-as-read';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all "Learn More" items available for the current user.
     * @param detailed (optional) 
     * @param includeAll (optional) 
     * @return OK
     */
    getAvailableLearnMore(detailed?: boolean | undefined, includeAll?: boolean | undefined): Promise<GetAvailableLearnMoreResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAvailableLearnMore(
            detailed,
            includeAll,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetAvailableLearnMoreResponse>(_response, false, ['lastUpdateDate', 'endDate']);
        });
    }

    /**
     * Marks a "Learn More" item as read for the current user.
     * @param id The unique identifier of the "Learn More" item to mark as read.
     * @return No Content
     */
    markAsReadLearnMore(id: number): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.markAsReadLearnMore(
            id,
        );

        const options = {
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }
}

export class LogsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        error: (
        ): string => {
            let clientRequestUrl = '/api/v3/logs/do-error';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        info: (
        ): string => {
            let clientRequestUrl = '/api/v3/logs/do-info';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        functional: (
        ): string => {
            let clientRequestUrl = '/api/v3/logs/do-functional';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Logs an error event.
     * @param body (optional) Details of the error that occurred.
     * @return No Content
     */
    error(body?: ClientLogError | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.error(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Log info
     * @param body (optional) Information log to create
     * @return No Content
     */
    info(body?: ClientLog | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.info(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Log functional
     * @param body (optional) Functional log to create
     * @return No Content
     */
    functional(body?: ClientLogFunctional | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.functional(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }
}

export class MyAccountsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getSettings: (
        ): string => {
            let clientRequestUrl = '/api/v3/my-accounts/settings';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getPersonalInformation: (
        ): string => {
            let clientRequestUrl = '/api/v3/my-accounts/personal-information';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all account settings for the current user.
     * @return OK
     */
    getSettings(): Promise<MyAccountSetting> {
        const clientRequestUrl = this.baseUrl + this.routes.getSettings(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<MyAccountSetting>(_response, false, []);
        });
    }

    /**
     * Retrieves the personal information of the current user.
     * @return OK
     */
    getPersonalInformation(): Promise<MyAccountPersonalInformation> {
        const clientRequestUrl = this.baseUrl + this.routes.getPersonalInformation(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<MyAccountPersonalInformation>(_response, false, []);
        });
    }
}

export class ServicesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getServices: (
			platform?: string | undefined,
			language?: string | undefined,
			accessType?: string | undefined,
			additionalServices?: string | undefined,
			enrichServiceInfo?: boolean | undefined,
			searchTerm?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/services?';
            if (platform === null) {
                throw new Error('The parameter "platform" cannot be null.');
            } else if (platform !== undefined) {
                clientRequestUrl += 'platform=' + encodeURIComponent('' + platform) + '&';
            }
            if (language === null) {
                throw new Error('The parameter "language" cannot be null.');
            } else if (language !== undefined) {
                clientRequestUrl += 'language=' + encodeURIComponent('' + language) + '&';
            }
            if (accessType === null) {
                throw new Error('The parameter "accessType" cannot be null.');
            } else if (accessType !== undefined) {
                clientRequestUrl += 'accessType=' + encodeURIComponent('' + accessType) + '&';
            }
            if (additionalServices === null) {
                throw new Error('The parameter "additionalServices" cannot be null.');
            } else if (additionalServices !== undefined) {
                clientRequestUrl += 'additionalServices=' + encodeURIComponent('' + additionalServices) + '&';
            }
            if (enrichServiceInfo === null) {
                throw new Error('The parameter "enrichServiceInfo" cannot be null.');
            } else if (enrichServiceInfo !== undefined) {
                clientRequestUrl += 'enrichServiceInfo=' + encodeURIComponent('' + enrichServiceInfo) + '&';
            }
            if (searchTerm === null) {
                throw new Error('The parameter "searchTerm" cannot be null.');
            } else if (searchTerm !== undefined) {
                clientRequestUrl += 'searchTerm=' + encodeURIComponent('' + searchTerm) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getRecommendedServices: (
			platform?: string | undefined,
			language?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/services/recommended?';
            if (platform === null) {
                throw new Error('The parameter "platform" cannot be null.');
            } else if (platform !== undefined) {
                clientRequestUrl += 'platform=' + encodeURIComponent('' + platform) + '&';
            }
            if (language === null) {
                throw new Error('The parameter "language" cannot be null.');
            } else if (language !== undefined) {
                clientRequestUrl += 'language=' + encodeURIComponent('' + language) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getEssentialServices: (
			language?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/services/essentials?';
            if (language === null) {
                throw new Error('The parameter "language" cannot be null.');
            } else if (language !== undefined) {
                clientRequestUrl += 'language=' + encodeURIComponent('' + language) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAllMergedServiceList: (
			onlyInfoService?: boolean | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/services/detailed?';
            if (onlyInfoService === null) {
                throw new Error('The parameter "onlyInfoService" cannot be null.');
            } else if (onlyInfoService !== undefined) {
                clientRequestUrl += 'onlyInfoService=' + encodeURIComponent('' + onlyInfoService) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getServicesLanguage: (
			language: string,
        ): string => {
            let clientRequestUrl = '/api/v3/services/translate/{language}';
            if (language === undefined || language === null) {
                throw new Error('The parameter "language" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{language}', encodeURIComponent('' + language));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all services available to the user.
     * @param platform (optional) Can be DesktopBrowser, MobileBrowser, IosApp or AndroidApp.
     * @param language (optional) Lang of Content. Default: en
     * @param accessType (optional) Indicate user access to services. Can be HasAccess, NoAccess, Both, HasAccessWithoutHiddenConsideration, BothForCatalog or All.
     * @param additionalServices (optional) Comma-separated list of additional sets of services to include.
    Supported values: nonSgmServices
     * @param enrichServiceInfo (optional) Add information about bookmark, ranking and visibility.
     * @param searchTerm (optional) Term used to search for services.
     * @return OK
     */
    getServices(platform?: string | undefined, language?: string | undefined, accessType?: string | undefined, additionalServices?: string | undefined, enrichServiceInfo?: boolean | undefined, searchTerm?: string | undefined): Promise<ServiceResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getServices(
            platform,
            language,
            accessType,
            additionalServices,
            enrichServiceInfo,
            searchTerm,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ServiceResponse>(_response, false, []);
        });
    }

    /**
     * Retrieves recommended services for the user.
     * @param platform (optional) The platform for which recommendations are requested.
     * @param language (optional) The language of the content. Defaults to "en".
     * @return OK
     */
    getRecommendedServices(platform?: string | undefined, language?: string | undefined): Promise<GetRecommendedServicesResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getRecommendedServices(
            platform,
            language,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetRecommendedServicesResponse>(_response, false, []);
        });
    }

    /**
     * Retrieves essential services for the user.
     * @param language (optional) The language of the content. Defaults to "en".
     * @return OK
     */
    getEssentialServices(language?: string | undefined): Promise<GetEssentialServicesResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getEssentialServices(
            language,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetEssentialServicesResponse>(_response, false, []);
        });
    }

    /**
     * Retrieves a list of all merged services.
     * @param onlyInfoService (optional) Indicates whether to retrieve only services that exist on the Info website.
     * @return OK
     */
    getAllMergedServiceList(onlyInfoService?: boolean | undefined): Promise<GetAllMergedServiceListResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAllMergedServiceList(
            onlyInfoService,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetAllMergedServiceListResponse>(_response, false, []);
        });
    }

    /**
     * Retrieves translated content for service keys.
     * @param language The language code (e.g., "en", "fr").
     * @return OK
     */
    getServicesLanguage(language: string): Promise<{ [key: string]: string; }> {
        const clientRequestUrl = this.baseUrl + this.routes.getServicesLanguage(
            language,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<{ [key: string]: string; }>(_response, false, [/* { [key: string]: string; } */]);
        });
    }
}

export class SignaturesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getSignature: (
        ): string => {
            let clientRequestUrl = '/api/v3/signatures';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        saveSignature: (
        ): string => {
            let clientRequestUrl = '/api/v3/signatures';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getSignatureBodyForCurrentUser: (
        ): string => {
            let clientRequestUrl = '/api/v3/signatures/me/body-details';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchBanners: (
        ): string => {
            let clientRequestUrl = '/api/v3/signatures/banners/do-search';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAllSections: (
        ): string => {
            let clientRequestUrl = '/api/v3/signatures/sections';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getTemplateById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v3/signatures/templates/{id}';
            if (id === undefined || id === null) {
                throw new Error('The parameter "id" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent('' + id));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAllLogos: (
        ): string => {
            let clientRequestUrl = '/api/v3/signatures/logos';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves the signature for the logged-in user.
     * @return OK
     */
    getSignature(): Promise<Signature> {
        const clientRequestUrl = this.baseUrl + this.routes.getSignature(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<Signature>(_response, false, []);
        });
    }

    /**
     * Saves a signature for the website www.sgmarkets.com.
     * @param body (optional) The signature to be saved.
     * @return No Content
     */
    saveSignature(body?: Signature | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.saveSignature(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Retrieves the signature content for the current user.
     * @return OK
     */
    getSignatureBodyForCurrentUser(): Promise<SignatureBodyResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getSignatureBodyForCurrentUser(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SignatureBodyResponse>(_response, false, []);
        });
    }

    /**
     * Search banners by various criteria
     * @param body (optional) 
     * @return OK
     */
    searchBanners(body?: SearchBannersRequest | undefined): Promise<SearchBannersResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.searchBanners(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SearchBannersResponse>(_response, false, []);
        });
    }

    /**
     * Get all sections
     * @return OK
     */
    getAllSections(): Promise<GetAllSectionsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAllSections(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetAllSectionsResponse>(_response, false, ['endDate']);
        });
    }

    /**
     * Get a template by its id
     * @param id The unique identifier of the template.
     * @return OK
     */
    getTemplateById(id: number): Promise<Template> {
        const clientRequestUrl = this.baseUrl + this.routes.getTemplateById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<Template>(_response, false, ['endDate']);
        });
    }

    /**
     * Get all logos
     * @return OK
     */
    getAllLogos(): Promise<GetAllLogosResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAllLogos(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetAllLogosResponse>(_response, false, []);
        });
    }
}

export class UserDisclaimersClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getUserDisclaimer: (
			application?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/user-disclaimers?';
            if (application === null) {
                throw new Error('The parameter "application" cannot be null.');
            } else if (application !== undefined) {
                clientRequestUrl += 'application=' + encodeURIComponent('' + application) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        validateUserDisclaimer: (
        ): string => {
            let clientRequestUrl = '/api/v3/user-disclaimers';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getLastValidatedContent: (
        ): string => {
            let clientRequestUrl = '/api/v3/user-disclaimers/last-validated-content';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        generateContent: (
			language?: string | undefined,
			application?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/user-disclaimers/do-generate-content?';
            if (language === null) {
                throw new Error('The parameter "language" cannot be null.');
            } else if (language !== undefined) {
                clientRequestUrl += 'language=' + encodeURIComponent('' + language) + '&';
            }
            if (application === null) {
                throw new Error('The parameter "application" cannot be null.');
            } else if (application !== undefined) {
                clientRequestUrl += 'application=' + encodeURIComponent('' + application) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all disclaimer information related to the specified application and the connected user.
     * @param application (optional) The application key for which disclaimers are retrieved.
     * @return OK
     */
    getUserDisclaimer(application?: string | undefined): Promise<GetUserDisclaimerResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getUserDisclaimer(
            application,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUserDisclaimerResponse>(_response, false, []);
        });
    }

    /**
     * Validates the disclaimer for the connected user and the specified application.
     * @param body (optional) The request containing the application information.
     * @return No Content
     */
    validateUserDisclaimer(body?: ValidateUserDisclaimerRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.validateUserDisclaimer(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Retrieves the last validated disclaimer content for the connected user.
     * @return OK
     */
    getLastValidatedContent(): Promise<GetUserDisclaimerContentResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getLastValidatedContent(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUserDisclaimerContentResponse>(_response, false, []);
        });
    }

    /**
     * Generates disclaimer content for the connected user based on the specified language and application.
     * @param language (optional) The language in which the disclaimer content should be generated.
     * @param application (optional) The application key for which the disclaimer content is generated.
     * @return OK
     */
    generateContent(language?: string | undefined, application?: string | undefined): Promise<GetUserDisclaimerContentResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.generateContent(
            language,
            application,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUserDisclaimerContentResponse>(_response, false, []);
        });
    }
}

export class UsersClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getContacts: (
			search?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v3/users/me/contacts?';
            if (search === null) {
                throw new Error('The parameter "search" cannot be null.');
            } else if (search !== undefined) {
                clientRequestUrl += 'search=' + encodeURIComponent('' + search) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        changeLanguage: (
			language: string,
        ): string => {
            let clientRequestUrl = '/api/v3/users/me/do-change-language/{language}';
            if (language === undefined || language === null) {
                throw new Error('The parameter "language" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{language}', encodeURIComponent('' + language));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getIntroTour: (
        ): string => {
            let clientRequestUrl = '/api/v3/users/me/introduction-tour';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Returns top 5 contacts (alphabetically) matching the search term
     * @param search (optional) search term
     * @return OK
     */
    getContacts(search?: string | undefined): Promise<GetContactsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getContacts(
            search,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetContactsResponse>(_response, false, []);
        });
    }

    /**
     * Change preferred language of current user
     * @return The update was successful
     */
    changeLanguage(language: string): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.changeLanguage(
            language,
        );

        const options = {
            method: 'PUT',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Returns the intro tour contents for the connected user
     * @return OK
     */
    getIntroTour(): Promise<any> {
        const clientRequestUrl = this.baseUrl + this.routes.getIntroTour(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<any>(_response, false, [/* any */]);
        });
    }
}

export class WidgetsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        addPersonWidget: (
        ): string => {
            let clientRequestUrl = '/api/v3/widgets/person-widgets/me';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        deletePersonWidget: (
			widgetType: WidgetType,
        ): string => {
            let clientRequestUrl = '/api/v3/widgets/person-widgets/me?';

            if (widgetType === undefined || widgetType === null) {
                throw new Error('The parameter "widgetType" must be defined and cannot be null.');
            } else {
                clientRequestUrl += 'widgetType=' + encodeURIComponent('' + widgetType) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        autoSubscribe: (
        ): string => {
            let clientRequestUrl = '/api/v3/widgets/do-auto-subscribe/me';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getMyWidgetDetails: (
        ): string => {
            let clientRequestUrl = '/api/v3/widgets/widget-details/me';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Add a person widget
     * @return Created
     */
    addPersonWidget(body: AddPersonWidgetRequest): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.addPersonWidget(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Delete a person Widget
     * @return No Content
     */
    deletePersonWidget(widgetType: WidgetType): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.deletePersonWidget(
            widgetType,
        );

        const options = {
            method: 'DELETE',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Auto add widgets to a user depending on user access
     * @return Created
     */
    autoSubscribe(): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.autoSubscribe(
        );

        const options = {
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Get widget details for the connected user
     * @return OK
     */
    getMyWidgetDetails(): Promise<MyWidgetDetailsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getMyWidgetDetails(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<MyWidgetDetailsResponse>(_response, false, []);
        });
    }
}

export interface AddPersonWidgetRequest {
    widgetType: WidgetType;
}

export enum AddressFormatEnum {
    Europe = "Europe",
    UK_US = "UK_US",
}

export interface ApplicationContext {
    user?: UserInfo | undefined;
    isSgNetwork?: boolean;
    isSignatureVisible?: boolean;
    isSubscriptionsVisible?: boolean;
    preferredLanguage?: string | undefined;
    is3SKeyVisible?: boolean;
    isSharinboxVisible?: boolean;
    hasOnlyB2b2cAccess?: boolean;
    canSearchPersonsAndCompanies?: boolean;
    isSgGroupCurrentUser?: boolean;
}

export interface BannerItem {
    id?: number;
    name?: string | undefined;
    imageUrl?: string | undefined;
    bannerLink?: string | undefined;
    templateId?: number;
    bannerSectionItems?: BannerSectionItem[] | undefined;
}

export interface BannerSectionItem {
    sectionId: number;
    sectionName: string | undefined;
    bannerRank?: number | undefined;
}

export enum BookmarkOrigin {
    SgmService = "SgmService",
    NonSgmService = "NonSgmService",
    SgDashboardBoard = "SgDashboardBoard",
}

export interface BookmarkResponse {
    /** Bookmark id tech */
    id?: number;
    /** Bookmarked identifier, for example ServiceKey for SgmService or Id of non sgm service from LinkReferential */
    referenceId?: string | undefined;
    /** Bookmarked origin (SgmService, NonSgmService from LinkReferential */
    origin?: BookmarkOrigin;
    /** Current User Ic Id, computed field */
    icId?: string;
    /** Page bookmarked, computed field */
    pageUrl?: string | undefined;
    /** Title, computed field */
    title?: string | undefined;
    /** Begin bookmark date, computed field */
    beginDate?: Date;
    /** Bookmarked SGM Service Initials, computed field */
    initials?: string | undefined;
    /** Related to type, for instance Sg Other service related to SGM, computed field */
    relationType?: RelationType | undefined;
    /** Whether is archived. It means the bookmarked service is archived */
    isArchived?: boolean | undefined;
}

/** Category */
export interface Category {
    key?: string | undefined;
    name?: string | undefined;
}

/** Client log */
export interface ClientLog {
    /** Message */
    message?: string | undefined;
    /** Custom Parameters */
    customParameters?: { [key: string]: any; } | undefined;
}

/** Client log error */
export interface ClientLogError {
    /** Message */
    message?: string | undefined;
    /** Custom Parameters */
    customParameters?: { [key: string]: any; } | undefined;
    /** Name */
    name?: string | undefined;
    /** Stack Trace */
    stackTrace?: string | undefined;
    /** Page Url */
    pageUrl?: string | undefined;
}

export interface ClientLogFunctional {
    /** Message */
    message?: string | undefined;
    /** Custom Parameters */
    customParameters?: { [key: string]: any; } | undefined;
    /** Feature */
    feature?: string | undefined;
}

export interface CompatiblePlatformsModel {
    desktop?: boolean;
    tablet?: boolean;
    smartphone?: boolean;
}

export interface CreateBookmarkDto {
    /** Bookmarked identifier, for example ServiceKey for SgmService or Id of non sgm service from LinkReferential */
    referenceId?: string | undefined;
    /** Bookmarked origin (SgmService, NonSgmService from LinkReferential) */
    origin?: BookmarkOrigin;
}

export interface DocumentationPage {
    label?: string | undefined;
    url?: string | undefined;
    exposure?: ExposureType;
}

export interface ErrorDto {
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ErrorDto[] | undefined;
}

/** User Essential Service dto */
export interface EssentialService {
    serviceKey?: string | undefined;
    rank?: number;
    title?: string | undefined;
    descriptions?: { [key: string]: string; } | undefined;
    url?: string | undefined;
    imgUrl?: string | undefined;
    /** Category */
    category?: Category | undefined;
    initials?: string | undefined;
    /** SubCategory */
    subcategory?: SubCategory | undefined;
    isInternal?: boolean;
    bookmarkId?: number | undefined;
    publicPageLink?: string | undefined;
}

export enum ExposureType {
    All = "All",
    Client = "Client",
    Staff = "Staff",
}

export interface GetAllLogosResponse {
    logos?: Logo[] | undefined;
}

export interface GetAllMergedServiceListResponse {
    mergedAllServices?: MergedAllService[] | undefined;
}

export interface GetAllSectionsResponse {
    sections?: Section[] | undefined;
}

export interface GetAvailableLearnMoreResponse {
    learnMoreItems?: LearnMoreItem[] | undefined;
}

export interface GetContactsResponse {
    contacts?: UserContact[] | undefined;
}

export interface GetEssentialServicesResponse {
    essentialServices?: EssentialService[] | undefined;
}

export interface GetRecommendedServicesResponse {
    services?: Service[] | undefined;
}

export interface GetServiceListResponse {
    infoServices?: { [key: string]: InfoService; } | undefined;
}

export interface GetUserBookmarksResponse {
    bookmarks?: BookmarkResponse[] | undefined;
}

export interface GetUserDisclaimerContentResponse {
    html?: string | undefined;
}

export interface GetUserDisclaimerResponse {
    needsDisclaimerValidation?: boolean;
    hasRestrictiveCountry?: boolean;
}

export enum HighlightLayoutPage {
    ForYou = "ForYou",
    Browse = "Browse",
}

export enum HighlightType {
    Service = "Service",
    ImageBanner = "ImageBanner",
    NonSgmService = "NonSgmService",
    InsightPublic = "InsightPublic",
    Recommended = "Recommended",
}

export interface InfoService {
    id: string;
    name?: string | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    visible?: boolean;
    themes?: string[] | undefined;
    logo?: string | undefined;
    images?: string[] | undefined;
    linksModel?: LinksModel | undefined;
    compatiblePlatforms?: CompatiblePlatformsModel | undefined;
    shareModel?: ShareModel | undefined;
    textModel?: TextModel | undefined;
    listModels?: ListModel[] | undefined;
}

export enum InsightPublicType {
    Insight = "Insight",
    Podcast = "Podcast",
}

export interface LearnMoreItem {
    id?: number;
    title?: string | undefined;
    titleFr?: string | undefined;
    contentUrl?: string | undefined;
    contentUrlFr?: string | undefined;
    imageUrl?: string | undefined;
    rank?: number;
    publicationHeadId?: number | undefined;
    tag?: LearnMoreTag;
    scope?: LearnMoreScope;
    targets?: string[] | undefined;
    content?: LearnMoreItemContentLang | undefined;
    lastUpdateDate?: Date;
    endDate?: Date | undefined;
}

export interface LearnMoreItemContent {
    title?: string | undefined;
    contents?: PublicationContent[] | undefined;
}

export interface LearnMoreItemContentLang {
    en?: LearnMoreItemContent | undefined;
    fr?: LearnMoreItemContent | undefined;
}

export enum LearnMoreScope {
    All = "All",
    Internal = "Internal",
    External = "External",
}

export enum LearnMoreTag {
    Story = "Story",
    Howto = "Howto",
    About = "About",
}

export interface LinksModel {
    requestAccess?: string | undefined;
    access?: string | undefined;
    jive?: string | undefined;
    video?: string | undefined;
}

export interface ListModel {
    icon?: string | undefined;
    en?: string | undefined;
    fr?: string | undefined;
}

export interface Logo {
    id?: number;
    key?: string | undefined;
    name?: string | undefined;
    url?: string | undefined;
}

export interface MergedAllService {
    serviceKey?: string | undefined;
    name?: string | undefined;
    initials?: string | undefined;
    isInternal?: boolean;
    url?: string | undefined;
    businessLines?: string[] | undefined;
    clientTypes?: string[] | undefined;
    countries?: string[] | undefined;
    excludedCountries?: string[] | undefined;
    category?: string | undefined;
    subCategory?: string | undefined;
    themes?: string[] | undefined;
    textModel?: TextModel | undefined;
    linksModel?: LinksModel | undefined;
    shareModel?: ShareModel | undefined;
    listModels?: ListModel[] | undefined;
    compatiblePlatforms?: CompatiblePlatformsModel | undefined;
    infoUrl?: string | undefined;
    pictureUrl?: string | undefined;
    visibilities?: VisibilityMessage[] | undefined;
    archived?: boolean;
    ressourceId?: string | undefined;
    onboardingContacts?: string | undefined;
    groupEmail?: string | undefined;
    groupEmailAgreementType?: string | undefined;
    groupEmailValidationLink?: string | undefined;
    securityLevel?: string | undefined;
}

export interface MyAccountPersonalInformation {
    civility?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    fullName?: string | undefined;
    company?: string | undefined;
    jobTitle?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressCity?: string | undefined;
    addressZipcode?: string | undefined;
    addressCountry?: string | undefined;
}

export interface MyAccountSetting {
    has2Factor?: boolean;
    canReset2FA?: boolean;
    hasPeriod2Factor?: boolean;
    hasPeriod2FactorActive?: boolean;
    expiredTime2FactorInDays?: number;
    notificationSettings?: NotificationSetting[] | undefined;
    isVisibleDisclaimerRequestPersonalData?: boolean;
    clientFullname?: string | undefined;
    clientBdrCommercialId?: string | undefined;
    userFullname?: string | undefined;
}

export interface MyHighlightImageBannerDto {
    title?: string | undefined;
    subTitle?: string | undefined;
    backgroundImageUrl?: string | undefined;
    linkUrl?: string | undefined;
}

export interface MyHighlightInsightPublicDto {
    serviceKey?: string | undefined;
    take?: number;
    insights?: MyHighlightInsightPublicItemDto[] | undefined;
}

export interface MyHighlightInsightPublicItemDto {
    publicationType?: InsightPublicType;
    title?: string | undefined;
    summary?: string | undefined;
    coverImageUrl?: string | undefined;
    link?: string | undefined;
    tags?: string | undefined;
    publicationDateUtc?: Date;
}

export interface MyHighlightItemDto {
    highlightType?: HighlightType;
    columnSizing?: number;
    service?: MyHighlightServiceDto | undefined;
    imageBanner?: MyHighlightImageBannerDto | undefined;
    nonSgmService?: MyHighlightNonSgmServiceDto | undefined;
    insightPublic?: MyHighlightInsightPublicDto | undefined;
    recommended?: MyHighlightRecommendedDto | undefined;
}

export interface MyHighlightLayoutDto {
    id?: number;
    title?: string | undefined;
    subTitle?: string | undefined;
    technicalName?: string | undefined;
    page?: HighlightLayoutPage;
    position?: number;
    categoryKey?: string | undefined;
    viewMoreTitle?: string | undefined;
    viewMoreUrl?: string | undefined;
    viewMoreTargetBlank?: boolean | undefined;
    items?: MyHighlightItemDto[] | undefined;
}

export interface MyHighlightLayoutsResponse {
    layouts?: MyHighlightLayoutDto[] | undefined;
}

export interface MyHighlightNonSgmServiceDto {
    ids?: string[] | undefined;
}

export interface MyHighlightRecommendedDto {
    serviceKeys?: string[] | undefined;
}

export interface MyHighlightServiceDto {
    serviceKey?: string | undefined;
}

export interface MyWidgetDetailsResponse {
    widgetDetails?: WidgetDetails[] | undefined;
}

/** DTO for services outside SG Markets */
export interface NonSgmService {
    id?: string | undefined;
    serviceKey?: string | undefined;
    title?: string | undefined;
    descriptions?: { [key: string]: string; } | undefined;
    url?: string | undefined;
    keywords?: { [key: string]: string[]; } | undefined;
    bookmarkId?: number | undefined;
    initials?: string | undefined;
    /** Related platform: for instance SGM */
    relatedTo?: string | undefined;
}

export interface NotificationSetting {
    name?: string | undefined;
    settingUrl?: string | undefined;
    initials?: string | undefined;
    internalOnly?: boolean;
    producerCode?: string | undefined;
}

export interface PublicationContent {
    bullet?: string | undefined;
    text?: string | undefined;
    pictureUrl?: string | undefined;
    pictureLink?: string | undefined;
}

export enum RelationType {
    RelatedToSgmPlatform = "RelatedToSgmPlatform",
    Page = "Page",
    Board = "Board",
}

export interface SearchBannersRequest {
    skip?: number | undefined;
    take?: number | undefined;
    onlyActive?: boolean;
    sectionIds?: number[] | undefined;
}

export interface SearchBannersResponse {
    banners: BannerItem[] | undefined;
}

export interface Section {
    id?: number;
    name?: string | undefined;
    rank?: number;
    bannerCount?: number;
    endDate?: Date | undefined;
}

export interface Service {
    serviceKey?: string | undefined;
    rank?: number;
    title?: string | undefined;
    descriptions?: { [key: string]: string; } | undefined;
    url?: string | undefined;
    imgUrl?: string | undefined;
    /** Category */
    category?: Category | undefined;
    initials?: string | undefined;
    infoUrl?: string | undefined;
    /** SubCategory */
    subcategory?: SubCategory | undefined;
    themes?: Theme[] | undefined;
    isInternal?: boolean;
    isBookmarked?: boolean;
    bookmarkId?: number | undefined;
    pictureUrl?: string | undefined;
    visibility?: VisibilityMessage | undefined;
    hasAccess?: boolean;
    hasDefaultAccessNone?: boolean;
    hasDefaultAccessAll?: boolean;
    servicePages?: ServicePage[] | undefined;
    sgmCatalog?: string | undefined;
    qumuId?: string | undefined;
    shareModel?: ShareModel | undefined;
    images?: string[] | undefined;
    features?: ListModel[] | undefined;
    descriptionText?: TextModel | undefined;
    documentationPages?: DocumentationPage[] | undefined;
    publicPageLink?: string | undefined;
}

export interface ServicePage {
    id?: string | undefined;
    label?: string | undefined;
    url?: string | undefined;
    exposure?: ExposureType | undefined;
}

/** ServiceResponse */
export interface ServiceResponse {
    /** Services which user has access to */
    services?: Service[] | undefined;
    /** SG services outside SG Markets */
    nonSgmServices?: NonSgmService[] | undefined;
    /** URL to form for adding more non-SGM services */
    nonSgmFormUrl?: string | undefined;
}

export interface ShareModel {
    en?: string[] | undefined;
    fr?: string[] | undefined;
}

export interface Signature {
    firstName?: string | undefined;
    lastName?: string | undefined;
    pronouns?: string | undefined;
    jobTitle?: string | undefined;
    jobTitlePart2?: string | undefined;
    department?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    zipCode?: string | undefined;
    directPhone?: string | undefined;
    mobilePhone?: string | undefined;
    emailAddress?: string | undefined;
    website?: string | undefined;
    freeText?: string | undefined;
    addressFormat?: AddressFormatEnum;
    disclaimer?: string | undefined;
    useDefaultDisclaimer?: boolean;
    bannerId?: number;
    templateId?: number | undefined;
    bannerLink?: string | undefined;
    signatureHtml?: string | undefined;
    templateUrl?: string | undefined;
    pictureUrl?: string | undefined;
    logoUrl?: string | undefined;
    logoId?: number | undefined;
}

export interface SignatureBodyResponse {
    signatureBody?: string | undefined;
}

/** SubCategory */
export interface SubCategory {
    key?: string | undefined;
    name?: string | undefined;
}

export interface Template {
    id?: number;
    name?: string | undefined;
    content?: string | undefined;
    endDate?: Date | undefined;
    bannerCount?: number;
}

export interface TextModel {
    en?: string[] | undefined;
    fr?: string[] | undefined;
}

/** Theme */
export interface Theme {
    key?: string | undefined;
    name?: string | undefined;
}

export interface UserContact {
    icId?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    readonly username?: string | undefined;
    company?: string | undefined;
}

export interface UserInfo {
    id?: string;
    email?: string | undefined;
    permissions?: string[] | undefined;
    name?: string | undefined;
    sgConnectId?: string;
    isInternal?: boolean;
    isSgLan?: boolean;
    company?: string | undefined;
    language?: string | undefined;
}

export interface ValidateUserDisclaimerRequest {
    application: string;
}

export interface VisibilityMessage {
    en?: string | undefined;
    fr?: string | undefined;
    key?: string | undefined;
}

export interface WidgetDetails {
    widgetType: WidgetType;
    isSubscribed: boolean;
    hasAccess: boolean;
    isAutoSubscriptionAvailable: boolean;
}

export enum WidgetType {
    SGM_MY_CASES = "SGM_MY_CASES",
    SGMARKETS = "SGMARKETS",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export class Utilities
{
    public static async processResponse<T>(
        response: Response,
        isFile: boolean,
        dateFields: string[],
    ): Promise<T> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status >= 200 && status < 300) {
            if (isFile) {
                const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
                const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers } as unknown as T; });
            }
            if (response && response.text) {
                return response.text().then((_responseText) => {
                    try {
                        const result: any = _responseText === '' ? null : JSON.parse(_responseText, (key, value) => {
                            if (value
                                && dateFields?.includes(key)
                                && (typeof value === 'string' || (Array.isArray(value) && value.every(i => typeof i === 'string'))) 
                                ) {
                               if (Array.isArray(value)) {
                                    return value.map(v => Utilities.ConvertToDate(v));
                                }
                                else {
                                    return Utilities.ConvertToDate(value);
                                }
                            }
                            return value;
                        }) as T;
                        return result;
                    } catch (error) {
                        return Promise.reject(new SwaggerException(error instanceof Error ? error.message : 'JSON.parse error', status, _responseText, _headers, null));
                    }
                });
            }
            else {
                return Promise.resolve<T>(<any>null);
            }
        }

        const errorMessage = status < 500 ? 'A server error occurred.' : 'An unexpected server error occurred.';

        if (response instanceof Error) {
        	return Promise.reject(new SwaggerException(response.message, status, response.message, _headers, null));
        }

        if (response && response.text) {
        	const responseText = await response.text();
        	return Promise.reject(new SwaggerException(errorMessage, status, responseText, _headers, null));
        }

        return Promise.resolve<T>(<any>null);
    }

    public static ConvertToDate (value: any) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date;
    }
}